function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 14.5,
  y1: 35.62,
  x2: 14.5,
  y2: 0.87,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b1c1e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c6d0e4"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-image-hard-drive-icon",
  width: 29,
  height: 31.38,
  rx: 2.53,
  ry: 2.53
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-image-hard-drive-icon",
  d: "M313.85,509H289.9c-1.4,0-2.53-.13-2.53-1.53v3A2.53,2.53,0,0,0,289.9,513h23.94a2.53,2.53,0,0,0,2.53-2.53v-3C316.38,508.87,315.24,509,313.85,509Zm-8.49,2.79h-7v-2h7Z",
  transform: "translate(-287.38 -476.63)"
});

var SvgVolumeDisk = function SvgVolumeDisk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg_hard_drive_icon",
    "data-name": "Restore Hard Drive Icon",
    viewBox: "0 0 29 36.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVolumeDisk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volumeDisk.21f8d6fd.svg";
export { ForwardRef as ReactComponent };